import type {
  QuoteItem,
  QuotePhase,
} from 'modules/finance/components/Quotes/QuotePhasesTable/types'

export const calculatePhaseTotalCost = (phase: QuotePhase): number => {
  return phase.items.reduce((total, item) => total + item.hoursOrUnits * item.costPerUnit, 0)
}

export const calculatePhaseTotalToBill = (phase: QuotePhase): number => {
  return phase.items.reduce((total, item) => total + item.hoursOrUnits * item.billPerUnit, 0)
}

export const calculatePhaseTotalHours = (phase: QuotePhase): number => {
  return phase.items.reduce((total, item) => {
    if (item.itemType === 'role') {
      return total + item.hoursOrUnits
    }
    return total
  }, 0)
}

export const calculatePhaseProfit = (phase: QuotePhase): number => {
  const totalCost = calculatePhaseTotalCost(phase)
  const totalToBill = calculatePhaseTotalToBill(phase)
  if (totalCost === 0) return 0
  return ((totalToBill - totalCost) / totalCost) * 100
}

export const calculateOverallTotals = (phases: QuotePhase[], standaloneItems: QuoteItem[] = []) => {
  const phasesTotalCost = phases.reduce((total, phase) => total + calculatePhaseTotalCost(phase), 0)
  const phasesTotalToBill = phases.reduce(
    (total, phase) => total + calculatePhaseTotalToBill(phase),
    0
  )
  const phasesTotalHours = phases.reduce(
    (total, phase) => total + calculatePhaseTotalHours(phase),
    0
  )

  const standaloneTotalCost = standaloneItems.reduce(
    (total, item) => total + item.hoursOrUnits * item.costPerUnit,
    0
  )
  const standaloneTotalToBill = standaloneItems.reduce(
    (total, item) => total + item.hoursOrUnits * item.billPerUnit,
    0
  )
  const standaloneTotalHours = standaloneItems.reduce((total, item) => {
    if (item.itemType === 'role') {
      return total + item.hoursOrUnits
    }
    return total
  }, 0)

  return {
    totalCost: phasesTotalCost + standaloneTotalCost,
    totalToBill: phasesTotalToBill + standaloneTotalToBill,
    totalHours: phasesTotalHours + standaloneTotalHours,
  }
}
